import { Container } from "react-bootstrap";
import { useLanguageContext, useThemeContext } from "../../../context";
import AppModal from "../AppModal";
import { CreateRoleComponent } from "../../common";

const CreateRoleModal = ({ toggle, setToggle, handleCreateRole, roles }) => {
  const { I18n } = useLanguageContext();

  const handleClose = (event) => {
    setToggle(false);
  };

  return (
    <AppModal
      className="createCustomerModal"
      toggle={toggle}
      handleClose={handleClose}
      title={I18n.create_role}
    >
      <Container>
        <CreateRoleComponent handleSelect={handleCreateRole} roles={roles} />
      </Container>
    </AppModal>
  );
};

export default CreateRoleModal;
